module.exports = __webpack_public_path__ + "img/my-type-3.8ea3daa2.png";